import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Mobile, Desktop } from './responsive';
import { Responsive, Spinner } from '~/components';
import { getSelectedMatchGrassStatusRequest } from '~/store/modules/matches/actions';
import EmptyPage from '~/pages/EmptyPage';

export default function GrassStatus() {
  const dispatch = useDispatch();
  const {
    grassStatus: { data: grassStatus, loading },
    selectedMatch: { data: selectedMatch },
    publicFiles,
  } = useSelector(state => state.matches);

  useEffect(() => {
    if (selectedMatch && !Object.keys(grassStatus).length) {
      dispatch(getSelectedMatchGrassStatusRequest(selectedMatch.id));
    }
  }, [dispatch, selectedMatch, grassStatus]);

  const irrigationProgram = () => {
    const {
      irrigationProgramBeforeWarmingStart,
      irrigationProgramBeforeWarmingEnd,
      irrigationProgramBeforeMatchStart,
      irrigationProgramBeforeMatchEnd,
      irrigationProgramDuringBreakStart,
      irrigationProgramDuringBreakEnd,
    } = grassStatus;
    return [
      {
        label: 'irrigationProgramBeforeWarming',
        start: irrigationProgramBeforeWarmingStart,
        end: irrigationProgramBeforeWarmingEnd,
      },
      {
        label: 'irrigationProgramBeforeMatch',
        start: irrigationProgramBeforeMatchStart,
        end: irrigationProgramBeforeMatchEnd,
      },
      {
        label: 'irrigationProgramDuringBreak',
        start: irrigationProgramDuringBreakStart,
        end: irrigationProgramDuringBreakEnd,
      },
    ];
  };

  const grassProps = {
    irrigationProgram: irrigationProgram(),
    grassStatus,
    publicFiles,
  };

  if (loading) return <Spinner isOpen isRelative />;
  if (selectedMatch && Object.keys(grassStatus).length) {
    return (
      <Responsive
        md={<Mobile {...grassProps} />}
        lg={<Desktop {...grassProps} />}
      />
    );
  }
  return <EmptyPage />;
}
